"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Sift = _interopRequireDefault(require("../Sift"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

var SiftProvider = function SiftProvider(_a) {
  var children = _a.children,
      settings = _a.settings,
      sift = _a.sift,
      sessionId = _a.sessionId;
  (0, _react.useEffect)(function () {
    if (settings.FEATURE.SIFT && sift) {
      _Sift["default"].initialize(sift, sessionId);
    }
  }, [sessionId, settings.FEATURE.SIFT, sift]);
  (0, _react.useEffect)(function () {
    window._sift && _Sift["default"].update();
  }, []);
  return _react["default"].createElement(_react["default"].Fragment, null, children);
};

var _default = SiftProvider;
exports["default"] = _default;